import http from './HttpService';
import { API_BASE_ANALYTICS, API_BASE_WORKFLOW } from '../../constants/index';
import { objectToQueryParams } from 'utils';
import axios from 'axios';

export const eventsService = async (searchTerm?: string) => {
  return await http.get(`${API_BASE_WORKFLOW}get_workflow_triggers/`, {});
};

let cancelTokenEmailsList: any;
export const emailsService = async (params: any) => {
  let url_params = objectToQueryParams(params);
  let url = `${API_BASE_WORKFLOW}get_user_emails/?${url_params}`;
  //Check if there are any previous pending requests
  if (typeof cancelTokenEmailsList != typeof undefined) {
    cancelTokenEmailsList && cancelTokenEmailsList.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenEmailsList = axios.CancelToken.source();
  return await http.get(url, {
    cancelToken: cancelTokenEmailsList.token,
  });
};

let cancelTokenContactsLists: any;
export const listsService = async (params: any) => {
  const url_params = objectToQueryParams(params);
  const url = `${API_BASE_WORKFLOW}get_user_contact_lists/?${url_params}`;
  if (typeof cancelTokenContactsLists != typeof undefined) {
    cancelTokenContactsLists && cancelTokenContactsLists.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenContactsLists = axios.CancelToken.source();
  return await http.get(url, {
    cancelToken: cancelTokenContactsLists.token,
  });
};

export const updateWorkflowService = async (data: any) => {
  const payload = mapFormData(data);
  return await http.post(`${API_BASE_WORKFLOW}update_workflow/`, payload, {});
};

export const getControls = async () => {
  return await http.get(`${API_BASE_WORKFLOW}get_workflow_controls/`);
};

export const createWorkflow = async (email_id: number, trigger_id: number, listId: number) => {
  const payload = new FormData();
  if (email_id > 0) payload.append('email_id', email_id.toString());
  if (listId > 0) payload.append('list_id', listId.toString());
  payload.append('trigger_id', trigger_id.toString());
  return await http.post(`${API_BASE_WORKFLOW}create_workflow/`, payload, {});
};

const mapFormData = (data: any) => {
  const payload = new FormData();
  for (let key in data) {
    payload.append(key, data[key]);
  }
  return payload;
};

// mapping for the data containing arrays or objects
export const mapFormDataWithStringify = (data: any) => {
  const payload = new FormData();
  for (let key in data) {
    if (typeof data[key] === 'object' && data[key] !== null) {
      payload.append(key, JSON.stringify(data[key]));
    } else {
      payload.append(key, data[key]);
    }
  }
  return payload;
};

export const getWorkflowDetailsService = async (workflowId: number) => {
  return await http.get(`${API_BASE_WORKFLOW}get_workflow_details/?workflow_id=${workflowId}`, {});
};

export const getUserWorkflowsService = async (
  offset: number,
  limit: number,
  workflowName?: string,
  filterType?: string,
) => {
  let url = `${API_BASE_WORKFLOW}get_user_workflows/?offset=${offset}&limit=${limit}`;
  if (workflowName && workflowName.length > 0) url = `${url}&workflow_name=${encodeURIComponent(workflowName)}`;
  if (filterType && filterType.length > 0) url = `${url}&filter_type=${filterType}`;
  return await http.get(url, {});
};

export const deleteWorkflowService = async (
  workflowIds: number[],
  selectAll: boolean,
  excludedWorkflowIds: number[],
  searchTerm: string,
  filterType: string,
) => {
  const payload = new FormData();
  const data = mapFormDataWithStringify({ workflowIds, excludedWorkflowIds });
  const workflowIdsArray = data.get('workflowIds');
  const excludedWorkflowIdsArray = data.get('excludeWorkflowIds');
  console.log(workflowIdsArray, excludedWorkflowIdsArray);
  if (selectAll) {
    payload.append('select_all', selectAll.toString());
    if (searchTerm.length > 0) payload.append('search_term', searchTerm);
    if (filterType.length > 0) payload.append('filter_type', filterType);
    if (excludedWorkflowIdsArray !== null) payload.append('excluded_workflow_ids', excludedWorkflowIdsArray);
  } else {
    if (searchTerm.length > 0) payload.append('search_term', searchTerm);
    if (filterType.length > 0) payload.append('filter_type', filterType);
    if (excludedWorkflowIdsArray !== null) payload.append('excluded_workflow_ids', excludedWorkflowIdsArray);
    if (workflowIdsArray !== null) payload.append('workflow_ids', workflowIdsArray);
  }
  return await http.post(`${API_BASE_WORKFLOW}delete_workflow/`, payload, {});
};

export const emailMappingService = async (data: object) => {
  const payload = mapFormDataWithStringify(data);
  return await http.post(`${API_BASE_WORKFLOW}email_mapping/`, payload, {});
};

export const getEmailLinks = async (data: object) => {
  return await http.get(`${API_BASE_WORKFLOW}get_workflow_details/?email_ids=${data}`, {});
};

export const getEmailsLinksService = async (data: string, nodeId: string, workflowId: number) => {
  return await http.get(
    `${API_BASE_WORKFLOW}get_emails_links/?email_ids=${data}&node_id=${nodeId}&workflow_id=${workflowId}`,
    {},
  );
};

export const sendTestShareProfileService = async (data: FormData) => {
  return await http.post(`${API_BASE_WORKFLOW}send_test_share_profile/`, data, {});
};

let cancelTokenSharedProfileStaticData: any;
export function getSharedProfileStaticDataService() {
  //Check if there are any previous pending requests
  if (typeof cancelTokenSharedProfileStaticData != typeof undefined) {
    cancelTokenSharedProfileStaticData &&
      cancelTokenSharedProfileStaticData.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenSharedProfileStaticData = axios.CancelToken.source();
  let url = `${API_BASE_WORKFLOW}get_user_static_data/`;
  return http.get(
    url,
    { cancelToken: cancelTokenSharedProfileStaticData.token }, //Pass the cancel token to the current request
  );
}

export const resumeWorkflowService = async (data: any) => {
  const payload = mapFormData(data);
  return await http.post(`${API_BASE_WORKFLOW}resume_workflow/`, payload, {});
};

export const cloneWorkflowService = async (data: any) => {
  const payload = mapFormData(data);
  return await http.post(`${API_BASE_WORKFLOW}clone_workflow/`, payload, {});
};

export const getWorkflowEmailsAnalyticsService = async (workflowId: number, searchTerm: string) => {
  if (typeof cancelTokenSharedProfileStaticData != typeof undefined) {
    cancelTokenSharedProfileStaticData &&
      cancelTokenSharedProfileStaticData.cancel('Operation canceled due to new request.');
  }

  //Save the cancel token for the current request
  cancelTokenSharedProfileStaticData = axios.CancelToken.source();
  let url = `${API_BASE_ANALYTICS}graph_email_listing/?workflow_id=${workflowId}&search_term=${encodeURIComponent(
    searchTerm,
  )}`;
  return http.get(
    url,
    { cancelToken: cancelTokenSharedProfileStaticData.token }, //Pass the cancel token to the current request
  );
};

export const getWorkflowEmailsGraphService = async (data: any) => {
  const payload = mapFormData(data);
  return await http.post(`${API_BASE_ANALYTICS}workflow_emails_graph/`, payload, {});
};
